module.exports = __webpack_public_path__ + "img/example-left-hand-side_1.1812be83.png";